import AddIcon from "@mui/icons-material/Add";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, Switch } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import { PsNoData } from "../../../components";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import ModuleAccess from "../../../context/moduleAccess";
import AppsIcon from "@mui/icons-material/Apps";
import {
  _DELETE_USER_ROLE,
  _LIST_USER_ROLES,
  _USER_ROLE_STATUS_UPDATE,
} from "../../../models/rbacModel";
import { upperCase } from "../../../utils";
import AppLayoutSecondaryHeader from "../../layout/AppLayout/AppLayoutSecondaryHeader";
import AddRoleForm from "./addRoleForm";
import EditRoleForm from "./editRoleForm";
import UserPermissionModal from "../userPermissions/userPermissionModal";

const RoleList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [addPermission, setAddPermission] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [viewData, setViewData] = useState([]);

  const { openDialog } = useDialog();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _LIST_USER_ROLES().then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
        setDataView(res.data);
      } else {
        setDataList([]);
        setDataView([]);
      }
      setLoader(false);
    });
  };

  const handleDeleteClick = (item) => {
    openDialog({
      title: "Confirm",
      message: `Do you want to Delete the Role ${item.role_name} ?`,
      onConfirm: () => confirmDelete(item),
    });
  };

  const confirmDelete = (item) => {
    setLoader(true);
    _DELETE_USER_ROLE({ id: item.id }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Deleted");
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Delete",
        });
        setLoader(false);
      }
    });
  };

  const handleStatusChange = (item, sta) => {
    openDialog({
      title: "Confirm",
      message: "Do you want to Update ?",
      onConfirm: () => confirmUpdate(item, sta),
    });
  };

  const confirmUpdate = (item, sta) => {
    setLoader(true);
    _USER_ROLE_STATUS_UPDATE({
      id: item.id,
      active_status: sta == "1" ? "0" : "1",
    }).then((res) => {
      if (res.status == "1") {
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
        setLoader(false);
      }
    });
  };

  const handleSearch = (e) => {
    let v = upperCase(e.target.value);
    let m = dataList.filter(
      (item) => upperCase(item.role_name).indexOf(v) > -1
    );
    setDataView(m);
  };

  const handleEditClick = (item) => {
    setViewData(item);
    setEditModal(true);
  };

  const handlePermissionEditClick = (item) => {
    setViewData(item);
    setAddPermission(true);
  };

  return (
    <>
      <AppLayoutSecondaryHeader title="Roles" backTo="/app/settings">
        <ModuleAccess module="user_roles" action="action_create">
          <IconButton
            color="inherit"
            onClick={(e) => setAddModal(true)}
            title="Add Module"
          >
            <AddIcon />
          </IconButton>
        </ModuleAccess>
        <IconButton color="inherit" onClick={(e) => loadData()} title="Refresh">
          <AutorenewIcon />
        </IconButton>
      </AppLayoutSecondaryHeader>
      <div className="container mt-115">
        <Row className="mb-2">
          <Col md={12}>
            <InputGroup size="sm">
              <InputGroup.Text>
                <SearchIcon />
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="fw-bold"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </InputGroup>
          </Col>
        </Row>

        <Spin spinning={loader}>
          <div>
            <Table size="sm" hover>
              <thead>
                <tr className="fs-12">
                  <th width="60" className="text-center">
                    S.No
                  </th>
                  <th width="">Role Name</th>
                  <th width="80" className="text-center">
                    Order
                  </th>
                  <th width="120" className="text-center">
                    Status
                  </th>
                  <th width="120" className="text-center">
                    #
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataView.map((item, i) => {
                  return (
                    <tr key={i} className="fs-12 valign-middle">
                      <td align="center">{i + 1}</td>
                      <td className="fw-bold">{item.role_name}</td>
                      <td align="center">{item.display_order}</td>
                      <td align="center">
                        <Switch
                          size="small"
                          checked={item.active_status == "1" ? true : false}
                          onChange={(e) =>
                            handleStatusChange(item, item.active_status)
                          }
                        />
                      </td>
                      <td align="center">
                        <ModuleAccess
                          module="user_permissions"
                          action="action_create"
                        >
                          <IconButton
                            title="Permissions"
                            onClick={(e) => handlePermissionEditClick(item)}
                          >
                            <AppsIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                        <ModuleAccess
                          module="user_roles"
                          action="action_update"
                        >
                          <IconButton
                            title="Edit"
                            onClick={(e) => handleEditClick(item)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                        <ModuleAccess
                          module="user_roles"
                          action="action_delete"
                        >
                          <IconButton
                            title="Delete"
                            onClick={(e) => handleDeleteClick(item)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                      </td>
                    </tr>
                  );
                })}
                {dataList.length < 1 && !loader && (
                  <tr>
                    <td colSpan={5}>
                      <PsNoData withHeight />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Spin>
      </div>

      <UserPermissionModal
        show={addPermission}
        onHide={(e) => {
          setAddPermission(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setAddPermission(false);
          setViewData([]);
          loadData();
        }}
        dataSource={viewData}
      />

      <AddRoleForm
        show={addModal}
        onHide={(e) => setAddModal(false)}
        onSuccess={() => {
          setAddModal(false);
          loadData();
        }}
      />
      <EditRoleForm
        show={editModal}
        dataSource={viewData}
        onHide={(e) => {
          setEditModal(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setEditModal(false);
          setViewData([]);
          loadData();
        }}
      />
    </>
  );
};
export default RoleList;
